import React from 'react';
import { SectionAlert, Txt } from '@vst/beam';
import { CalendarToday } from '@vst/beam-icons/icons';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

import { DateFormat } from '@app/constants';
import { Container } from '@app/components/Container';
import { SuccessOutcome } from '@app/components/ScheduleInstallation';
import { SelectedDate } from '@app/hooks';
import { formatTimeInterval } from '@app/redux/scheduleInstallation';

import { ScheduleInput } from '@mfe/shared/schema-types';

type ScheduleSuccessProps = {
  goToOverview: () => void;
  selectedDate: SelectedDate;
  selectedInterval: ScheduleInput | null;
};

export const ScheduleSuccess = ({ goToOverview, selectedDate, selectedInterval }: ScheduleSuccessProps) => {
  const { t } = useTranslation('ScheduleInstallation', {
    keyPrefix: 'AppointmentScheduled',
  });

  const formattedDate =
    selectedDate.day &&
    selectedDate.month &&
    selectedDate.year &&
    format(new Date(selectedDate.year, selectedDate.month - 1, selectedDate.day), DateFormat.SHORT_MONTH_DAY);
  return (
    <Container mt="56px">
      <SuccessOutcome goToOverview={goToOverview}>
        <Txt data-cy="appointmend-scheduled-title" mt="48px" mb="40px" variant="bodyLargeBold">
          {t('title')}
        </Txt>

        <SectionAlert
          data-cy="appointmend-scheduled-SectionAlert"
          variant="infoPrimary"
          mb="40px"
          contentSlot={
            <div>
              <Txt color="regular" component="span" variant="smallBold">
                {t('alertTitle')}
              </Txt>
              <Txt color="regular" component="span" variant="smallRegular">
                {t('alertContent', {
                  DATE: formattedDate,
                  TIME: formatTimeInterval([selectedInterval?.from ?? '', selectedInterval?.to ?? '']),
                })}
              </Txt>
            </div>
          }
          icon={CalendarToday}
        />
      </SuccessOutcome>
    </Container>
  );
};
